import { getSearchQueryParamsForAPI } from 'src/utils/url.helpers';

// DRUG codes are excluded as they don't work with Volume By Location (VBL) endpoints
const VALID_CODE_TYPES = new Set([
  'CPT',
  'HCPCS',
  'ICD',
  'ICD10D',
  'ICD10P',
  'ICDP',
  'DRG',
]);

// Maps internal code types to API query parameter names
// Based on backend LEGACY_CODE_TYPE_DICT mapping
const CODE_TYPE_TO_PARAM: Record<string, string> = {
  CPT: 'cpt',
  HCPCS: 'hcpcs',
  ICD: 'icd',
  ICD10D: 'icd',
  ICD10P: 'icdp',
  ICDP: 'icdp',
  DRG: 'drg',
};

/**
 * Build query params for the top-providers-at-site and volume-by-location
 * endpoints from a widget's code set (decomposed into code-type params)
 * and optional filter set ID (provider filter).
 */
export const buildTopProvidersQueryParams = (
  codeSet: MedScout.FilterSet | null,
  minYear?: number,
  maxYear?: number,
  filterSetId?: number | null,
  encounterId?: number | null
): string => {
  let params = '';

  if (codeSet?.filters?.length) {
    const filterValues = codeSet.filters.reduce(
      (acc: Record<string, string[]>, filter) => {
        const codeTypeUpper = filter.type.toUpperCase();
        if (VALID_CODE_TYPES.has(codeTypeUpper) && filter.values?.length > 0) {
          const paramName =
            CODE_TYPE_TO_PARAM[codeTypeUpper] || filter.type.toLowerCase();
          acc[paramName] = filter.values;
        }
        return acc;
      },
      {}
    );

    params = getSearchQueryParamsForAPI(filterValues);
  }

  if (minYear != null || maxYear != null) {
    params = getSearchQueryParamsForAPI(
      {
        dateRange: {
          gte: String(minYear),
          lte: String(maxYear),
        },
      },
      params
    );
  }

  if (filterSetId != null) {
    params = getSearchQueryParamsForAPI(
      { filter_set: String(filterSetId) },
      params
    );
  }

  if (encounterId != null) {
    params = getSearchQueryParamsForAPI(
      { cohort_id: String(encounterId) },
      params
    );
  }

  return params;
};
